/* @flow */
import React from 'react'
import MultiSelect from './MultiSelect'
import type {ActiveFilters, Lang, Mode} from './App'
import type { OnSelectChange, MultiselectOption } from './MultiSelect'
import labels from './labels'
import {capitalize} from "./globals";

export type OnInputChange = (event: SyntheticEvent<>, { value: string }) => void

type Props = {
  categories: Array<MultiselectOption>,
  currencies: Array<MultiselectOption>,
  risks: Array<MultiselectOption>,
  activeFilters: ActiveFilters,
  lang: Lang,
  width: number,
  mode: Mode,
  handleSelectInput:  OnSelectChange,
  handleSearchInput: OnInputChange,
  clearSearchInput: (event: SyntheticEvent<>) => void
}

class Filters extends React.Component<Props> {
  render() {
    const { categories, currencies, risks, activeFilters, handleSelectInput, handleSearchInput, lang, clearSearchInput, width, mode } = this.props
    const { search } = activeFilters
    return (
      <div className="ui segment ac-filters__segment">
        <div className="ui stackable grid">
          <div className="four column row">
            <div className={`${width < 992 ? 'sixteen' : 'three'} wide column`}>
              <div
                className="ui fluid icon input" >
                <input
                  value={search}
                  onChange={handleSearchInput}
                  placeholder={labels[lang].search}/>
                  {
                    search
                    ? <i aria-hidden="true" className="close link icon" onClick={clearSearchInput}></i>
                    : <i aria-hidden="true" className="search link icon"></i>
                  }
              </div>
            </div>
            <div className={`${width < 992 ? 'sixteen' : 'seven'} wide column`}>
              <MultiSelect
                name='category'
                placeholder={labels[lang]['selCat' + capitalize(mode)]}
                value={activeFilters.category}
                options={categories}
                onChange={handleSelectInput}
              />
            </div>
            <div className={`${width < 992 ? 'sixteen' : 'two'} wide column`}>
              <MultiSelect
                name='currency'
                placeholder={labels[lang].selCur}
                value={activeFilters.currency}
                options={currencies}
                onChange={handleSelectInput}
              />
            </div>
            { mode !== 'compensa' &&
              <div className={`${width < 992 ? 'sixteen' : 'two'} wide column`}>
                <MultiSelect
                    name='risk'
                    placeholder={labels[lang].selRisk}
                    value={activeFilters.risk}
                    options={risks}
                    onChange={handleSelectInput}
                />
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default Filters



// WEBPACK FOOTER //
// ./src/Filters.js